import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getAuthHeader } from '../services/tokenService';

export default function MandatControleStripe({ mandatId }) {
  const [d, setD] = useState(null);
  const charger = async () => {
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sepa-stripe/admin/mandats/${mandatId}/controle-stripe`, { headers: getAuthHeader() });
      setD(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || 'Contrôle impossible'); }
  };
  if (!d) return <button type="button" onClick={charger} className="block rounded border px-2 py-0.5" data-testid={`mandat-controle-${mandatId}`}>Contrôle Stripe</button>;
  return (
    <div className="text-[11px] text-slate-700 min-w-[260px]" data-testid={`mandat-controle-resultat-${mandatId}`}>
      <div>Client : <span className="font-mono">{d.stripe_customer_id || '—'}</span></div>
      <div className={d.stripe_recovery_hold ? 'text-emerald-700' : 'text-red-700'}>{d.stripe_recovery_hold ? 'Prélèvements bloqués' : 'Prélèvements NON bloqués'}</div>
      {d.stripe_recovery_hold_history.map((h) => <div key={h.at} className="text-slate-500">{h.actif ? 'Bloqué' : 'Débloqué'} le {new Date(h.at).toLocaleString('fr-FR')} par {h.par} ({h.motif})</div>)}
      <div className="mt-1">Échéances :</div>
      {d.echeances.map((e) => <div key={e.numero}>n° {e.numero} — {e.date.split('-').reverse().join('/')} — {e.montant.toFixed(2)} € — {(d.prelevements[String(e.numero)] || {}).statut || 'aucun prélèvement'}</div>)}
      <div className="mt-1">PaymentIntent Stripe (tous statuts) : {d.payment_intents.length}</div>
      {d.payment_intents.map((p) => <div key={p.id} className="font-mono">{p.id} — {p.montant.toFixed(2)} {p.devise} — {p.statut}</div>)}
    </div>
  );
}
